import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

type RankingType = 'hot' | 'rating';

interface RankingSectionProps {
  type?: RankingType;
}

export default function RankingSection({ type = 'hot' }: RankingSectionProps) {
  const sorted = type === 'hot'
    ? [...comics].sort((a, b) => b.views - a.views).slice(0, 8)
    : [...comics].sort((a, b) => b.rating - a.rating).slice(0, 8);

  const title = type === 'hot' ? '热门排行榜' : '高分推荐';

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {title}
            </h2>
            <p className="text-sm text-foreground-500">
              {type === 'hot' ? '根据阅读量排名，发现最受欢迎的漫画' : '评分最高的漫画佳作推荐'}
            </p>
          </div>
          {type === 'hot' && (
            <Link
              to="/category/hanman"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {sorted.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-colors cursor-pointer group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 whitespace-nowrap ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </span>
              <div className="w-12 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - ${title}`}
                  title={`${comic.title} - 女神漫画`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{comic.author}</span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                    {comic.category === 'hanman' ? '韩漫' : comic.category === 'riman' ? '日漫' : '国漫'}
                  </span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-0.5 text-sm text-primary-500 font-medium">
                  <i className="ri-star-fill text-xs"></i>
                  {comic.rating}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">
                  {(comic.views / 10000).toFixed(0)}万
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}